import { Today } from "../../../utils/Constant";

export const timeLineData = [
    {
        color:"primary",
        date:"30-06-2023",
        day:Today,
        Product:"Updated Product",
        describe:"Quisque a consequat ante sit amet."
    },
    {
        color:"dark",
        date:"30-06-2023",
        day:Today,
        Product:"James just like your product",
        describe:"Design and style should work toward making look good."
    },
    {
        color:"secondary",
        date:"25-06-2023",
        day:Today,
        badge:"New",
        Product:"Jihan Doe just like your product",
        describe:"If you have it, you can make anything look good.",
        img:true

    }
]